// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.search-input{align-items:center;background-color:#fff;display:flex;margin:auto;width:100%}@media(min-width:750px){.search-input{max-width:80%}}@media(min-width:1100px){.search-input{max-width:700px}}.search-input__field{background-color:#fff;border:0;font-size:22px;line-height:1;margin-left:15px;width:100%}.search-input__erase{padding:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
